var exports = {
  "kL": "MobileBottomNav.module__container___R19nTX",
  "oi": "MobileBottomNav.module__navButton___R19nTX",
  "Mv": "MobileBottomNav.module__navButtonActive___R19nTX",
  "XA": "MobileBottomNav.module__navButtonInactive___R19nTX",
  "VK": "MobileBottomNav.module__voiceButton___R19nTX",
  "Kk": "MobileBottomNav.module__icon___R19nTX",
  "Pf": "MobileBottomNav.module__label___R19nTX",
};

module.exports = exports;
